import type { JSX } from 'react';

import classNames from 'classnames';

import { NOTIFICATION_LABEL, relativeTime } from '../supportFormat';

import type { SupportNotificationNode } from './notificationOps';
import styles from './NotificationRowContent.module.css';

/**
 * One notification, as the bell panel and the notifications page both show it:
 * unread dot, what happened, which ticket, and when.
 */
export function NotificationRowContent({
  notification,
  size = 'compact',
}: {
  notification: SupportNotificationNode;
  size?: 'compact' | 'roomy';
}): JSX.Element {
  const unread = !notification.readAt;
  const createdAt = notification.createdAt as unknown as string | Date;
  const at = typeof createdAt === 'string' ? new Date(createdAt) : createdAt;

  return (
    <span className={classNames(styles.Row, size === 'roomy' && styles.Roomy)}>
      <span className={classNames(styles.Dot, unread && styles.DotUnread)} aria-hidden="true" />
      <span className={styles.Text}>
        <span className={styles.Head}>
          <span className={styles.Kind}>{NOTIFICATION_LABEL[notification.kind]}</span>{' '}
          <span className={styles.Title}>{notification.title || 'Untitled'}</span>
          {unread && <span className={styles.VisuallyHidden}> (unread)</span>}
        </span>
        <span className={styles.Meta}>
          {notification.ticketNumber} · <time dateTime={at.toISOString()}>{relativeTime(at)}</time>
        </span>
      </span>
    </span>
  );
}
